import React, { memo } from 'react';
import { Flex } from 'antd-mobile';
import PropTypes from 'prop-types';
import { ImgWrap } from 'pubBiz';
import styles from './index.modules.less';
import { PriceText } from 'widget';

const defaultProps = {
  data: {},
  showSellPoint: false,
  sellPointList: [],
  productParams: {}
};

// sellPoint成员结构
const sellPointPropTypes = PropTypes.shape({
  sellPointColour: PropTypes.string, // 卖点颜色（不含#）
  sellPointName: PropTypes.string // 卖点文案
});

// data成员结构
const dataPropTypes = PropTypes.shape({
  id: PropTypes.string, // 商品ID
  itemId: PropTypes.string, // 商品ID（兼容字段）
  imgUrl: PropTypes.string, // 商品图片
  name: PropTypes.string, // 商品名称
  price: PropTypes.number, // 商品价格
  maxPrice: PropTypes.number, // 商品最高价格
  type: PropTypes.number // 商品类型（6：多规格商品）
});

// props成员结构
const propTypes = {
  width: PropTypes.number.isRequired, // 商品展示宽度
  data: PropTypes.arrayOf(dataPropTypes),
  config: PropTypes.shape({
    reverse: PropTypes.bool, // 开启这个属性后，产品名称和卖点的顺序会互换
    radius: PropTypes.string // 圆角值
  }),
  showSellPoint: PropTypes.bool, // 是否显示卖点
  sellPointList: PropTypes.arrayOf(sellPointPropTypes),
  productParams: PropTypes.object, // 商品参数
  onPress: PropTypes.func // 点击事件回调
};

const GoodItem = memo((props) => {
  const {
    width, // Number 宽度
    data, // Object 商品数据
    showSellPoint, // Boolean 是否显示卖点
    sellPointList, // Array 卖点
    config, // Object 配置
    productParams, // Object 商品参数
    onPress // Function 点击事件
  } = props;

  const {
    imgUrl, // String 商品图片
    name, // String 商品名称
    price, // Number 商品价格
    maxPrice, // Number 商品最高价格
    type // Number 商品类型 type=6 多规格商品
  } = data;

  const {
    reverse = false, // Boolean 开启这个属性后，产品名称和卖点的顺序会互换
    radius = 0 // String 圆角值
  } = config || {};

  // 点击事件
  const handlePress = () => {
    const { id } = data;
    onPress && onPress();
    window.app.routerGoTo({ pathname: `/shop/productDetail/${id}`, state: productParams });
  };

  const renderSellPoint = () => {
    if (!showSellPoint) return null;

    return (
      <Flex direction="row" align="center" className={styles.sellPointContainer}>
        {(sellPointList || []).map((item, index) => {
          const { sellPointColour, sellPointName } = item;
          return (
            <Flex
              key={`sellPoint-${index}`}
              align="center"
              justify="center"
              className={styles.sellPointWrapper}
              style={{
                marginLeft: !index ? 0 : '0.08rem',
                border: `1px solid ${sellPointColour && sellPointColour.indexOf('#') > -1 ? sellPointColour : `#${sellPointColour}`}`
              }}>
              <div
                className={styles.sellPoint}
                style={{
                  color: `${sellPointColour && sellPointColour.indexOf('#') > -1 ? sellPointColour : `#${sellPointColour}`}`
                }}>
                <span>{sellPointName}</span>
              </div>
            </Flex>
          );
        })}
      </Flex>
    );
  };

  return (
    <Flex
      direction="column"
      style={{ width, background: '#fff', borderRadius: radius, overflow: 'hidden' }}
      onClick={() => handlePress()}>
      {/* 商品图片 */}
      <ImgWrap w={width} h={width} src={imgUrl} mode="cover" />
      <Flex direction="column" align="start" className={styles.wrapper}>
        {reverse && (
          <React.Fragment>
            {renderSellPoint()}
            <div className={styles.name}>
              <span>{name}</span>
            </div>
          </React.Fragment>
        )}
        {!reverse && (
          <React.Fragment>
            <div className={styles.name}>
              <span>{name}</span>
            </div>
            {renderSellPoint()}
          </React.Fragment>
        )}

        {/* 商品价格 */}
        <Flex direction="row" align="center">
          <PriceText
            value={price}
            showSymbol={false}
            showIcon
            className={styles.priceText}
            unitClassName={styles.priceTextSmall}
            integerClassName={styles.priceTextBig}
            decimalClassName={styles.priceTextSmall}
            tail={() => {
              if (type != 6 || price >= maxPrice) return null;
              return <div className={styles.priceExtra}>起</div>;
            }}
          />
        </Flex>
      </Flex>
    </Flex>
  );
});

GoodItem.defaultProps = defaultProps;
GoodItem.propTypes = propTypes;

export default GoodItem;



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/components/GoodItem/index.js